<template>
  <v-container
    style="padding: 0; margin: auto; border-radius: 5px; background: white"
  >
    <v-form ref="entryForm" @submit.prevent="submit" :disabled="loading">
      <v-card flat style="border-bottom: 1px solid black; margin-bottom: 20px">
        <div class="position-relative" style="height: 25px">
          <router-link to="/asset-management/pemakaian-aset">
            <v-btn
              text
              color="black"
              class="black--text font-weight-bold"
              x-small
              type="button"
              outlined
              style="position: absolute; right: -90px"
              :loading="loading"
              :disabled="loading"
            >
              <v-icon x-small>mdi-chevron-left</v-icon>
              Kembali
            </v-btn>
          </router-link>
        </div>
        <div class="d-flex justify-space-between" style="width: 100%">
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 10px;
            "
          >
            <v-toolbar-title class="overline">
              <p style="font-size: 20px; margin: 0; font-weight: bold">
                Formulir Pemakaian Aset
              </p>
            </v-toolbar-title>
          </div>
          <v-btn
            :loading="loading"
            :disabled="loading"
            type="submit"
            elevation="0"
            color="primary"
            class="white--text font-weight-bold ma-1"
            style="font-size: 12px"
            small
          >
            Kirim
          </v-btn>
        </div>
      </v-card>

      <v-row style="padding: 15px; margin-top: 10px">
        <v-col md="3" style="padding: 0">
          <div style="padding: 0 10px">
            <v-col cols="12" style="padding: 0">
              <p
                style="
                  margin: 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                Nama PIC
              </p>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <v-text-field
                :value="getUserProfile.employee.name"
                dense
                readonly
                style="margin: 0"
              />
            </v-col>
          </div>
        </v-col>
        <v-col md="3" style="padding: 0">
          <div style="padding: 0 10px">
            <v-col cols="12" style="padding: 0">
              <p
                style="
                  margin: 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                PIC Perusahaan
              </p>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <v-text-field
                :value="getUserProfile.employee.company.name"
                dense
                readonly
                style="margin: 0"
              />
            </v-col>
          </div>
        </v-col>
        <v-col md="3" style="padding: 0">
          <div style="padding: 0 10px">
            <v-col cols="12" style="padding: 0">
              <p
                style="
                  margin: 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                Department
              </p>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <v-text-field
                :value="getUserProfile.employee.department.name"
                dense
                readonly
                style="margin: 0"
              />
            </v-col>
          </div>
        </v-col>
        <v-col md="3" style="padding: 0">
          <div style="padding: 0 10px">
            <v-col cols="12" style="padding: 0">
              <p
                style="
                  margin: 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                Email
              </p>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <v-text-field
                :value="getUserProfile.employee.email"
                dense
                readonly
                style="margin: 0"
              />
            </v-col>
          </div>
        </v-col>
      </v-row>

      <v-row style="padding: 15px; margin-top: 10px">
        <v-col md="3" style="padding: 0">
          <div style="padding: 0 10px">
            <v-col cols="12" style="padding: 0">
              <p
                style="
                  margin: 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                Tgl Pemakaian
              </p>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <v-text-field
                v-model="form.planned_date"
                clearable
                outlined
                dense
                type="date"
                name="date"
                step="1"
              />
            </v-col>
          </div>
        </v-col>
        <!-- <v-col md="3" style="padding: 0">
          <div style="padding: 0 10px">
            <v-col cols="12" style="padding: 0">
              <p
                style="
                  margin: 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                Tgl Aktual
              </p>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <v-text-field
                v-model="form.actual_date"
                clearable
                outlined
                dense
                type="date"
                name="date"
                step="1"
              />
            </v-col>
          </div>
        </v-col> -->
        <v-col md="3" style="padding: 0">
          <div style="padding: 0 10px">
            <v-col cols="12" style="padding: 0">
              <p
                style="
                  margin: 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                Digunakan Oleh
              </p>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <v-select
                :items="dropdownCompany"
                v-model="form.company"
                style="height: 30px"
                label="Ketik Nama Perusahaan"
                item-text="name"
                item-value="id"
                return-object
                outlined
                dense
              ></v-select>
            </v-col>
          </div>
        </v-col>
        <v-col md="3" style="padding: 0">
          <div style="padding: 0 10px">
            <v-col cols="12" style="padding: 0">
              <p
                style="
                  margin: 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                Lokasi Pemakaian
              </p>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <v-text-field
                v-model="form.usage_location"
                clearable
                outlined
                dense
                label="Ketik lokasi"
              />
            </v-col>
          </div>
        </v-col>
      </v-row>
      <v-row style="padding: 15px">
        <v-col md="12" style="padding: 0 10px">
          <v-card
            flat
            style="
              top: 0;
              background: white;
              margin-top: 20px;
              margin-bottom: 40px;
            "
          >
            <v-btn
              elevation="2"
              small
              @click="addItem"
              rounded
              outlined
              color="indigo"
              class="indigo--text font-weight-bold ma-2"
              style="font-size: 12px; margin-bottom: 5px"
            >
              Tambah item</v-btn
            >
            <v-data-table
              mobile-breakpoint="0"
              :headers="headers"
              :items="form.items"
              class="elevation-1 mx-auto"
              style="
                width: 100%;
                margin-bottom: 10px;
                border: 1px solid #e0e0e0;
              "
              :items-per-page="10"
              hide-default-footer
            >
              <template v-slot:[`header.action`]>
                <span
                  >Aksi
                  <v-tooltip bottom>
                    <template v-slot:activator="{ attrs, on }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="red lighten-2"
                        style="margin: 0"
                        x-small
                        @click="removeAll"
                        :disabled="form.items.length == 0"
                      >
                        mdi-delete-circle
                      </v-icon>
                    </template>
                    <span>Delete All</span>
                  </v-tooltip>
                </span>
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <div style="font-size: 12px; width: 160px; padding: 0">
                  {{ item.name }}
                </div>
              </template>
              <template v-slot:[`item.lot_no`]="{ item }">
                <div style="font-size: 12px; width: 60px; padding: 0">
                  {{ item.lot_no }}
                </div>
              </template>
              <template v-slot:[`item.company_name`]="{ item }">
                <div style="font-size: 12px; width: 210px; padding: 0">
                  {{ item.company_name }}
                  <!-- / {{ item.location_name }} -->
                </div>
              </template>
              <template v-slot:[`item.current_location_name`]="{ item }">
                <div style="font-size: 12px; width: 210px; padding: 0">
                  {{
                    item.current_company_name +
                    ' - ' +
                    item.current_location_name
                  }}
                </div>
              </template>
              <!-- <template v-slot:[`item.new_lot_no`]="{ item }">
                <div style="padding: 0; display: flex; flex-direction: row">
                  <div style="height: 40px; width: 210px" v-if="form.is_sell">
                    <v-text-field v-model="item.new_lot_no" dense outlined />
                  </div>
                </div>
              </template> -->
              <template v-slot:[`item.qty_available`]="{ item }">
                <div style="font-size: 12px; width: 60px; padding: 0">
                  {{ item.qty_available }}
                </div>
              </template>
              <template v-slot:[`item.qty_move`]="{ item }">
                <div style="padding: 0">
                  <div style="height: 40px; width: 90px">
                    <v-text-field
                      v-model="item.qty"
                      dense
                      outlined
                      type="number"
                      min="0"
                      max="9999"
                      :rules="[
                        (v) => v >= 0 || 'Min 0',
                        (v) => v <= 9999 || 'Max 9999'
                      ]"
                    />
                  </div>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item, index }">
                <div style="font-size: 12px; width: 40px; padding: 0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        text
                        icon
                        x-small
                        color="red lighten-2"
                        @click="remove(item, index)"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding: 15px">
        <v-col md="12" style="padding: 0">
          <div style="padding: 0 10px">
            <v-col cols="4" style="padding: 0">
              <p
                style="
                  margin: 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                Keterangan Tambahan
              </p>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <v-textarea v-model="form.description" dense auto-grow outlined />
            </v-col>
          </div>
        </v-col>
      </v-row>
    </v-form>
    <add-item
      @getLot="initLot"
      :formData="form"
      :lotHeaders="headers"
      :dropdownCompany="dropdownCompany"
    />
  </v-container>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import buildType from '../../../services/buildType'
export default {
  components: {
    AddItem: () => import('./components/AddItem')
  },
  data() {
    return {
      upload: buildType.apiURL('upload2'),
      eSanqua: buildType.apiURL('esanqua'),
      asset: buildType.apiURL('asset'),
      loading: false,
      form: {
        description: null,
        planned_date: null,
        actual_date: null,
        company: null,
        items: [],
        qty_used: 0
      },
      headers: [
        {
          text: 'Aksi',
          value: 'action',
          align: 'left',
          sortable: false
        },
        { text: 'Nama Aset', value: 'name', align: 'left', sortable: false },
        // {
        //   text: 'Kode Aset',
        //   value: 'asset_code',
        //   align: 'left',
        //   sortable: false
        // },
        { text: 'Kode Lot', value: 'lot_no', align: 'left', sortable: false },
        {
          text: 'Tersedia',
          value: 'qty_available',
          align: 'left',
          sortable: false
        },
        {
          text: 'Digunakan',
          value: 'qty_used',
          align: 'left',
          sortable: false
        },
        {
          text: 'Kepemilikan',
          value: 'company_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Lokasi asal',
          value: 'current_location_name',
          align: 'left',
          sortable: false
        }
        // {
        //   text: 'Kode Baru',
        //   value: 'new_lot_no',
        //   align: 'left',
        //   sortable: false
        // },
      ],
      dropdownCompany: [],
      isUpload: false,
      uploadMessage: []
    }
  },
  mounted() {
    this.form.company = {
      id: Number(this.getUserProfile.employee.company.plant_id),
      name: this.getUserProfile.employee.company.name
    }
    this.getDropdownCompany()
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  methods: {
    ...mapActions(['dropdownAsset']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    rowClick(pItem) {
      console.log(pItem)
    },
    getDropdownCompany() {
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.dropdownCompany = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    initLot(pItem) {
      for (let i = 0; i < pItem.length; i++) {
        console.log(pItem[i])
        const a = {
          company_id: pItem[i].company_id,
          company_name: pItem[i].company_name,
          current_location_name: pItem[i].current_location_name,
          current_company_name: pItem[i].current_company_name,
          lot_id: Number(pItem[i].id),
          lot_no: pItem[i].name,
          name: pItem[i].asset_name,
          qty_used: parseFloat(pItem[i].qty_used),
          qty_available: parseFloat(pItem[i].qty)
        }
        this.form.items.push(a)
      }
    },
    addItem() {
      if (this.form.items.length > 0) {
        return this.showMsgDialog(
          'warning',
          'Untuk saat ini tidak dapat menambahkan lebih dari 1 item',
          false
        )
      }
      setTimeout(() => {
        document.getElementById('addItemUsage').click()
      }, 500)
    },
    submit() {
      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      const newForm = {
        usage_location: this.form.usage_location,
        planned_date: this.form.planned_date,
        actual_date: this.form.actual_date,
        description: this.form.description
      }
      if (this.form.items && this.form.items.length > 0) {
        Object.assign(newForm, {
          lot_id: this.form.items[0].lot_id,
          qty_used: this.form.items[0].qty_used
        })
      }
      if (this.form.company) {
        Object.assign(newForm, {
          company_id: Number(this.form.company.id),
          company_name: this.form.company.name
        })
      }
      console.log('newForm>>>', newForm)
      this.save(newForm)
    },
    save(form) {
      this.loading = true
      axios
        .post(`${this.asset}usage/save`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.$router.push(
              `/asset-management/detail-pemakaian/${res.data.created_id}`
            )
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    console.log('HERE 3')
                    xFlag = true
                  }
                } else {
                  console.log('HERE 2')
                  xFlag = true
                }
              } else {
                console.log('HERE 1')
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    remove(pItem, index) {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin menghapus item ini ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          this.form.items.splice(index, 1)
        }
      })
    },
    removeAll() {
      if (this.form.items.length > 0) {
        this.showMsgDialog(
          'question',
          'Anda yakin ingin menghapus semua item dibawah ini ?',
          true
        ).then((res) => {
          if (res.isConfirmed) {
            this.form.items = []
          }
        })
      } else {
        this.showMsgDialog('warning', 'Tidak ada item untuk dihapus', false)
      }
    },
    clear() {
      this.form = {
        description: null,
        planned_date: null,
        actual_date: null,
        company: null,
        items: [],
        qty_used: 0
      }
    }
  }
}
</script>
